/**
 * @generated SignedSource<<3937a83f86794b94feb2c11231b4203c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkCompleted_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkCompletedPixCreditCard_query">;
  readonly " $fragmentType": "PaymentLinkCompleted_query";
};
export type PaymentLinkCompleted_query$key = {
  readonly " $data"?: PaymentLinkCompleted_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkCompleted_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkCompleted_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkCompletedPixCreditCard_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "37e42442924d0027a8605c6b08e1cfd0";

export default node;
